export const CityFilter = ({ cities, selectedCity, onCityChange }) => {
  if (!cities || cities.length === 0) {
    return null;
  }

  return (
    <div className="city-filter">
      <label htmlFor="city-select">Filtrar por ciudad:</label>
      <select 
        id="city-select"
        value={selectedCity || ''} 
        onChange={(e) => onCityChange(e.target.value)}
      >
        <option value="">Todas las ciudades</option>
        {cities.map((city) => (
          <option key={city.id} value={city.id}>
            {city.name}
          </option>
        ))}
      </select>
    </div>
  );
};
